/**
 * Configuration types for home page sections
 * Enables fully configurable sections with no hardcoded content
 */

export type SectionType =
  | 'design-every-corner'
  | 'curated-design-collections'
  | 'expert-curated-collections'
  | 'style-inspirations'
  | 'find-your-perfect-match'
  | 'trending-now'
  | 'special-offers'
  | 'shop-by-category';

export type StyleVariant = string;

export type AspectRatio = '1/1' | '4/3' | '16/9' | '3/4' | 'auto';
export type Gap = 'none' | 'xs' | 'sm' | 'md' | 'lg';

export interface Link {
  href: string;
  label?: string;
  openInNewTab?: boolean;
}

export interface SectionItem {
  id: string;
  src: string;
  alt: string;
  title?: string;
  subtitle?: string;
  badge?: string;
  link?: Link;
  priority?: boolean;
}

export interface Carousel {
  enabled: boolean;
  autoPlayMs?: number;
  loop?: boolean;
  showDots?: boolean;
}

export interface Columns {
  base: number;
  md?: number;
  lg?: number;
}

export interface SectionConfig {
  type: SectionType;
  style: StyleVariant;
  heading: string;
  description?: string;
  items: SectionItem[];
  columns?: Columns;
  aspectRatio?: AspectRatio;
  gap?: Gap;
  carousel?: Carousel;
}

export interface HomePageConfig {
  sections: SectionConfig[];
}

// Style variants per section type
export const STYLE_VARIANTS = {
  'design-every-corner': ['original', 'hero-minimal', 'mosaic-bold'],
  'curated-design-collections': ['original', 'cards-elevated', 'grid-quiet'],
  'expert-curated-collections': ['original', 'profiled-list', 'tiles-with-notes'],
  'style-inspirations': ['original', 'pill-carousel', 'stacked-posters'],
  'find-your-perfect-match': ['quiz-teaser', 'grid-cta'],
  'trending-now': ['original', 'marquee-strip', 'waterfall', 'simple-cards'],
  'special-offers': ['original', 'classic-cards', 'banner-contrast', 'coupon-grid'],
  'shop-by-category': ['original'],
} as const;

